function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.284 13.714h10.662a.765.765 0 00.765-.765 5.34 5.34 0 00-5.336-5.33h-1.519a5.336 5.336 0 00-5.33 5.33.762.762 0 00.758.765z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.047,
  cy: 3.047,
  r: 3.047,
  transform: "translate(20.573)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.19 19.808a5.34 5.34 0 00-5.33-5.336H5.336A5.343 5.343 0 000 19.808a.762.762 0 00.765.758h10.666a.758.758 0 00.758-.758z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.047,
  cy: 3.047,
  r: 3.047,
  transform: "translate(3.051 6.857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.663 14.472H41.14a5.34 5.34 0 00-5.33 5.336.758.758 0 00.758.758H47.23a.762.762 0 00.765-.758 5.343 5.343 0 00-5.332-5.336z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.047,
  cy: 3.047,
  r: 3.047,
  transform: "translate(38.858 6.857)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.622 33.521a7.619 7.619 0 10-7.62-7.617 7.619 7.619 0 007.62 7.617z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.903 35.804h-4.571a9.918 9.918 0 00-9.9 9.907.758.758 0 00.758.758h22.855a.762.762 0 00.765-.758 9.921 9.921 0 00-9.907-9.907z"
}));

function SvgShareholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 46.47,
    viewBox: "0 0 48 46.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareholder);
export default __webpack_public_path__ + "static/media/shareholder.43d22c6f.svg";
export { ForwardRef as ReactComponent };